<template>
  <base-tile :title="$t('users.profile')" i18nPrefix="users" :rows="state.rows">
    <template #[state.readCountrySlot]>
      <td class="p-2">
        {{ state.country ? regionNames.of(state.country) : "/" }}
      </td>
    </template>
    <template #actions>
      <va-button
        class="mr-2"
        @click="openEditNameModal"
        icon="edit"
      >
        {{ $t("buttons.edit") }}
      </va-button>
    </template>
  </base-tile>
  <edit-user-name-modal
    :is-open="state.showEditNameModal"
    :user-id="store.state.identity.user.id"
    :initial-display-name="store.state.identity.user.displayName"
    :initial-given-name="store.state.identity.user.givenName"
    :initial-family-name="store.state.identity.user.familyName"
    @cancel="cancelEditName"
    @validate="validateEditName"
  />
</template>

<script setup>
import { computed, reactive } from "vue";
import { useI18n } from "vue-i18n";
import { useStore } from "vuex";
import BaseTile from "@/components/BaseTile.vue";
import EditUserNameModal from "@/components/modal/EditUserNameModal.vue";

const { t } = useI18n();
const store = useStore();
const regionNames = new Intl.DisplayNames(["en"], { type: "region" });

const state = reactive({
  givenName: store.state.identity.user.givenName,
  familyName: store.state.identity.user.familyName,
  locale: store.state.identity.user.locale,
  country: store.state.identity.user.country,
  phoneNumber: store.state.identity.user.phoneNumber,
  showEditNameModal: false,
  rows: computed(() => {
    const user = store.state.identity.user;
    return [
      {
        label: t("users.displayName"),
        value: user.displayName || "/"
      },
      {
        label: t("users.firstName"),
        value: user.givenName || "/"
      },
      {
        label: t("users.lastName"),
        value: user.familyName || "/"
      },
      {
        label: t("users.locale"),
        value: user.locale
          ? t(`general.languages.${user.locale.substring(0, 2)}`)
          : "/"
      },
      {
        label: t("users.country"),
        value: user.country
      }
    ];
  }),
  readCountrySlot: `${t("users.country")}-value`
});

const openEditNameModal = () => {
  state.showEditNameModal = true;
};

const cancelEditName = () => {
  state.showEditNameModal = false;
};

const validateEditName = async () => {
  state.showEditNameModal = false;
  await store.dispatch("identity/fetchUser", store.state.identity.user.id);
};
</script>
